import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
export const LayoutType = new Enum(['LAYOUT_TYPE_DO_NOT_USE', 'FIXED', 'TILE', 'RAIL']);

// Remote device settings for point of sale devices
export default ProtoBaseModel.extend({
  layoutType: attr(LayoutType),
  fixedLayoutRows: attr(Number),
  fixedLayoutColumns: attr(Number)
});